import { configureStore } from '@reduxjs/toolkit'
import mediaPlayerReducer from './mediaPlayerSlice'
import bandDiscographyReducer from './bandDiscographySlice'

export default configureStore({
  reducer: {
    mediaPlayer: mediaPlayerReducer,
    bandDiscography: bandDiscographyReducer,
  },
})